import { Box, Text, Button, Flex, Avatar, type AvatarProps } from '@vibe/core';
import { AppModal, AppModalContent } from '@gorilla/ui/src/components/AppModal';
import { Heading } from '@vibe/core';
import { ExternalPage, Check } from '@vibe/icons';
import { monday } from '../services/monday';

// Not one of Vibe's named colors; Avatar passes unknown values through as a raw CSS color.
const checkAvatarColor = '#6161ff' as AvatarProps['backgroundColor'];

type CustomizationModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export function CustomizationModal({ isOpen, onClose }: CustomizationModalProps) {
  return (
    <AppModal
      show={isOpen}
      onClose={() => {
        onClose();
      }}
      contentSpacing={false}
      alertDialog={false}
      width={800}
      id="customization__modal"
    >
      <AppModalContent>
        <div
          style={{
            margin: '24px 16px 24px 16px',
          }}
        >
          <Flex justify="start" align="start" direction="row" gap={48}>
            <Box style={{ overflow: 'visible', width: 'calc(100% / 2)' }}>
              <Flex justify="start" align="start" direction="column" gap={30}>
                <Flex justify="start" align="start" direction="column" gap={15}>
                  <Flex gap={14}>
                    <div
                      style={{
                        overflow: 'hidden',
                        borderRadius: '7px',
                        lineHeight: 0,
                      }}
                    >
                      <img src="/clientportalbuilder_app_icon.png" width="40" height="40" alt="Client Portal Builder" />
                    </div>
                    <Heading type="h2" weight="bold" align="start">
                      Custom Client Portal
                    </Heading>
                  </Flex>
                  <Text type="text1" align="start" color="secondary" element="p">
                    You have needs beyond the current set of features for your Client Portal? Our customization services got you covered
                    with custom themes, layouts and individual content sections.
                  </Text>
                  <Flex gap={8} direction="column" justify="start" align="start" style={{ marginTop: '16px', width: '100%' }}>
                    <Flex gap={16} justify="start">
                      <Avatar size="small" type="icon" icon={Check} withoutBorder backgroundColor={checkAvatarColor} />
                      <Text type="text1" align="start" color="secondary" element="p">
                        Communicate with clients via item comments
                      </Text>
                    </Flex>
                    <Flex gap={16}>
                      <Avatar size="small" type="icon" icon={Check} withoutBorder backgroundColor={checkAvatarColor} />
                      <Text type="text1" align="start" color="secondary" element="p">
                        Let clients update boards via forms
                      </Text>
                    </Flex>
                    <Flex gap={16}>
                      <Avatar size="small" type="icon" icon={Check} withoutBorder backgroundColor={checkAvatarColor} />
                      <Text type="text1" align="start" color="secondary" element="p">
                        Engage clients to sign e.g. contracts
                      </Text>
                    </Flex>
                    <Flex gap={16}>
                      <Avatar size="small" type="icon" icon={Check} withoutBorder backgroundColor={checkAvatarColor} />
                      <Text type="text1" align="start" color="secondary" element="p">
                        Display subitems on detail pages
                      </Text>
                    </Flex>
                  </Flex>
                  <Text type="text3" align="start" color="secondary" element="p" style={{ marginTop: '24px' }}>
                    These are just a few examples which do enhance your clients user experience. Pretty much anything you can imagine is
                    possible.
                  </Text>
                </Flex>
              </Flex>
            </Box>
            <Box style={{ overflow: 'visible', width: 'calc(100% / 2)' }}>
              <Flex gap={30} direction="column" justify="start" align="start">
                <Box
                  rounded="small"
                  shadow="medium"
                  style={{
                    lineHeight: 0,
                  }}
                >
                  <img
                    src="/client-portal-for-monday-dashboard-x2c42et7bfgpvzx.webp"
                    width=""
                    height=""
                    alt=""
                    style={{ width: '100%', height: 'auto' }}
                  />
                </Box>
                <Text type="text1" align="start" color="secondary" element="p">
                  Thanks to the underlaying flexible framework and extension system, we are able to perfectly tailor your Client Portal to
                  your unique requirements. Book a call now or learn more down below.
                </Text>
                <Box>
                  <Flex gap={16}>
                    <Button
                      leftIcon={ExternalPage}
                      kind="secondary"
                      size="medium"
                      color="inverted"
                      className="custom__publishbutton custom__publishbutton--secondary"
                      onClick={() => {
                        monday.execute('openLinkInTab', { url: 'https://calendly.com/d/z5z-yb9-bxw/30min' });
                      }}
                    >
                      Book a call
                    </Button>
                    <Button
                      leftIcon={ExternalPage}
                      kind="primary"
                      size="medium"
                      color="inverted"
                      className="custom__publishbutton"
                      onClick={() => {
                        monday.execute('openLinkInTab', { url: 'https://getgorilla.app/service' });
                      }}
                    >
                      Learn more
                    </Button>
                  </Flex>
                </Box>
              </Flex>
            </Box>
          </Flex>
        </div>
      </AppModalContent>
    </AppModal>
  );
}
